export enum DocumentType {
    boleto,
    extratosPrevidenciarios,
    informeRendimentos
}